import React from 'react'
import styled from 'styled-components'

import { Panel } from 'components/Panel'
import { NoData } from 'styles/shared'

import { color } from 'styles/colors'

type props = {
  notes: string
}

const Notes = ({ notes }: props) => {
  return (
    <S.Panel>
      <S.PanelHeader>
        <Panel.Title>Notes</Panel.Title>
      </S.PanelHeader>
      {!notes
        ? <S.NoData><h1>Add notes here</h1></S.NoData>
        : <S.Note><S.NoteText>{notes}</S.NoteText></S.Note>
      }
    </S.Panel>
  )
}

export default Notes

const S = {
  NoData: styled(NoData)`
    h1 {
      font-size: 28px;
    }
  `,
  Panel: styled(Panel)`
    border-bottom: 0px;
    padding: 0px;
    width: calc(100% - 0px);
    height: 308px;
  `,
  PanelHeader: styled(Panel.Header)`
    padding-right: 4px;
  `,
  Note: styled.div`
    background-color: ${color('dashboardBackground')};
    max-height: 275px;
    border-radius: 10px;
  `,
  NoteText: styled.p`
    padding: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.5em;
    display: -webkit-box;
    -webkit-line-clamp: 11;
    -webkit-box-orient: vertical;
    max-height: calc(1.5em * 12.2);
    color: ${color('LastUpdatedText')};
  `
}
